/* eslint-disable func-names */
/**
 * @file
 */

(($, Drupal) => {
  // eslint-disable-next-line no-param-reassign
  Drupal.behaviors.troaxImageCarousel = {
    attach() {
      const owl = $('.owl-carousel').once('troaxImageCarousel');
      const dots = $('.owl-dot');
      const dotsWrapper = $('#carousel-custom-dots');

      if (dots.length <= 1) {
        dotsWrapper.css('display', 'none');
      }

      owl.each(function () {
        const $this = $(this);

        $this.owlCarousel({
          items: 1,
          dotSpeed: 600,
          navSpeed: 600,
          nav: false,
          autoWidth: false,
          dotsContainer: '#carousel-custom-dots',
        });
      });

      dots.click(function () {
        owl.trigger('to.owl.carousel', [$(this).index(), 300]);
      });

      owl.magnificPopup({
        delegate: '.item img',
        type: 'image',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
          tPrev: 'Previous (Left arrow key)', // title for left button
          tNext: 'Next (Right arrow key)', // title for right button
          tCounter: '<span class="mfp-counter">%curr% of %total%</span>', // markup of counter
        },
        callbacks: {
          elementParse(img) {
            const item = img;
            item.src = item.el.attr('src');
          },
        },
      });
    },
  };
})(jQuery, Drupal);
